import enUS from "./en-us";
import ru from "./ru";
import kz from "./kz";
import ro from "./ro";

import kg from "./kg";
import tg from "./tg";
import uz from "./uz";

export default {
  en: enUS,
  ru,

  // NOTE: Выпилить после выхода международки
  kz,
  ro,

  kg,
  tg,
  uz,
};
